var uriTemplates = require('uri-templates');
var util = require('../lib/util.es6');

var Pastebin = Backbone.Model.extend({
    initialize: function (data, options) {
        this.session = options.session;
        if (!this.get('extension')) {
            this.set('extension', this.parseExtension(), {silent: true});
        }
        this.on('removed', function () {
            this.stopListening();
        }, this);
    },
    getUrl: function () {
        if (this.id) {
            return uriTemplates(window.IRCConfig.pastebin_uri_template).fill({
                id: this.id,
                name: this.get('name')
            });
        } else {
            return this.get('external_url');
        }
    },
    getRawUrl: function () {
        if (this.id) {
            var data = {
                type: 'raw',
                id: this.id
            };
            if (this.get('name')) {
                data.name = this.get('name');
            }
            return uriTemplates(window.IRCConfig.pastebin_uri_template).fill(data);
        } else {
            return this.get('external_raw_url');
        }
    },
    getJSONUrl: function () {
        return this.session.backend.buildRawUrl('/pastebin/json/' + this.id);
    },
    getTheme: function () {
        return this.session.getTheme(this.get('theme'));
    },
    isOwn: function () {
        return !!this.get('own_paste');
    },
    getDate: function () {
        return new Date(this.get('date') * 1000);
    },
    parseExtension: function () {
        return Pastebin.parseExtension(this.get('name'));
    },
    getBody: function () {
        // nbsp -> ' '
        return (this.get('body') || '').replace(/\u00a0/g, ' ');
    },
    isTooLarge: function () {
        if (this.getBody() && util.lengthInUtf8Bytes(this.getBody()) > Pastebin.MAX_LENGTH_BYTES) {
            return true;
        }
        return false;
    },
    remove: function (callback) {
        return this.session.post('delete-pastebin', {
            id: this.id
        }, _.bind(function (response) {
            if (response.success || response.message == 'not_found') {
                this.trigger('removed');
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    save: function (data, callback) {
        return this.session.post('paste', data, _.bind(function (response) {
            this.set(response);
            if (callback) {
                callback(response);
            }
        }, this));
    },
    editMultipart: function (data, callback) {
        var formData = new window.FormData();
        formData.append('id', this.id);
        for (var k in data) {
            formData.append(k, data[k]);
        }
        var promise = this.session.ajax({
            url: this.session.backend.buildRawUrl('/chat/edit-pastebin-multipart'),
            type: 'post',
            data: formData,
            dataType: 'json',
            headers: {
                'x-irccloud-session': this.session.getAuthCookie()
            },
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            },
            // Options to tell jQuery not to process data or worry about content-type.
            contentType: false,
            processData: false
        }, function (response) {
            return !!response && response.success;
        });
        promise.done(_.bind(function (response, status, jqXHR) {
            this.set(response.paste);
            this.trigger('edited');
            if (callback) {
                callback(response);
            }
        }, this));
        promise.fail(_.bind(function (jqXHR, errorString, response) {
            if (callback) {
                callback(response);
            }
        }, this));
    },
    editPost: function (data, callback) {
        data.id = this.id;
        return this.session.post('edit-pastebin', data, _.bind(function (response) {
            if (response.success) {
                this.set(response.paste);
                this.trigger('edited');
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    edit: function (data, callback) {
        this.editMultipart(data, callback);
    },
    fetch: function () {
        var url = this.getJSONUrl();
        return this.session.ajax({
            url: url,
            dataType: 'json',
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            }
        }, function (response) {
            return !!response.id;
        }, function (request) {
            return request.status != 404;
        }).done(_.bind(function (response, statusText, request) {
            if (statusText == 404) {
                this.trigger('removed');
            } else {
                this.set(response);
                this.trigger('loaded');
            }
        }, this)).fail(_.bind(function (request, errorString, errorThrown) {
            this.trigger('fetchError', request.status, request.responseText);
        }, this));
    }
}, {
    MAX_LENGTH_BYTES: 50000,
    parseExtension: function (name) {
        if (name) {
            var extMatch = name.match(/\.(\w+)$/);
            if (extMatch) {
                return extMatch[1].toLowerCase();
            }
        }
        return 'txt';
    }
});


module.exports = Pastebin;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/pastebin.js
// module id = RvJ1
// module chunks = 1